export default "<template>\n  <FdSection title=\"Section title\">\n    <FdPanel>Panel</FdPanel>\n  </FdSection>\n</template>"